module.exports = __webpack_public_path__ + "static/dennis-crupi-13c1d790bb63885f40578b7b15deab60.png";